import React, { useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { formatApiError } from "../../lib/errors";
import { OfflinePaymentOptions } from "../OfflinePaymentOptions";

export const OfflineReceiptForm = ({ item, onConfirmed }) => {
    const [method, setMethod] = useState(item.method === "check" ? "check" : "cash");
    const [delivery, setDelivery] = useState(item.delivery || "drop_off");
    const [reference, setReference] = useState("");
    const [busy, setBusy] = useState(false), [error, setError] = useState("");
    const prefix = `receipt-${item.kind}-${item.id}`;
    const submit = async event => {
        event.preventDefault();
        if (busy) return;
        setBusy(true); setError("");
        try {
            const body = { payment_method: method, received_via: delivery, payment_reference: reference.trim() };
            if (item.kind === "raffle") await api.patch(`/admin/raffles/${item.raffle_id}/entries/${item.id}/pay`, body);
            else await api.post(`/admin/orders/${item.id}/confirm-offline-payment`, body);
            toast.success(item.kind === "raffle" ? "Payment received — raffle tickets issued." : "Payment received — order marked paid.");
            onConfirmed();
        } catch (err) { setError(formatApiError(err, "Could not confirm payment. Refresh and try again.")); }
        finally { setBusy(false); }
    };
    return <form onSubmit={submit} data-testid={`${prefix}-form`} className="space-y-4 min-w-0">
        <p data-testid={`${prefix}-amount`} className="text-sm font-medium break-words">{item.name} · ${Number(item.amount).toFixed(2)} awaiting payment</p>
        <OfflinePaymentOptions method={method} delivery={delivery} onChange={(m, d) => { setMethod(m); setDelivery(d); }} prefix={prefix} disabled={busy} allowCashMail={item.kind === "raffle"} />
        <label className="block text-sm">Check number / receipt reference <span className="text-xs text-[#4A5568]">(optional)</span><input data-testid={`${prefix}-reference`} disabled={busy} maxLength={200} value={reference} onChange={e => setReference(e.target.value)} className="mt-1 block w-full rounded-lg border border-black/15 px-3 py-2" /></label>
        {error && <p role="alert" data-testid={`${prefix}-error`} className="text-sm text-red-700">{error}</p>}
        <button type="submit" data-testid={`${prefix}-submit`} disabled={busy || !item.can_confirm} className="w-full rounded-full px-4 py-2.5 bg-emerald-700 hover:bg-emerald-800 text-white text-sm font-medium transition-colors disabled:opacity-50">{busy ? "Confirming…" : `Confirm $${Number(item.amount).toFixed(2)} received`}</button>
    </form>;
};